/**
 * Star of Wellbeing Cache Management Utility
 * Handles clearing all cached data related to star of wellbeing assessments
 */

const STAR_WELLBEING_CACHE_PREFIXES = [
  'lifepsensor_star_wellbeing_cache', // Main star wellbeing cache
  'lifepsensor_insights_cache',       // Insights cache used in assessments
  'lifepsensor_wellness_assessments_cache', // Wellness assessments cache
  'lifepsensor_health_assessments_cache'    // Health assessments cache
];

/**
 * Clears all cached data related to star of wellbeing
 * This includes star wellbeing data, insights, wellness assessments, and health assessments
 */
export const clearAllStarWellbeingCache = (): void => {
  try {
    const keysToRemove: string[] = [];

    // Collect all matching cache keys
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && STAR_WELLBEING_CACHE_PREFIXES.some(prefix => key.startsWith(prefix))) {
        keysToRemove.push(key);
      }
    }

    // Remove all collected keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);

    });

  } catch (error) {

  }
};

/**
 * Clears star wellbeing cache for a specific user
 * @param userId The user ID to clear cache for
 */
export const clearStarWellbeingCacheForUser = (userId: string): void => {
  try {
    const keysToRemove: string[] = [];

    STAR_WELLBEING_CACHE_PREFIXES.forEach(prefix => {
      const userSpecificKey = `${prefix}_${userId}`;
      const generalKey = prefix;

      // Check and collect user-specific key
      if (localStorage.getItem(userSpecificKey)) {
        keysToRemove.push(userSpecificKey);
      }

      // Check and collect general key (for backward compatibility)
      if (localStorage.getItem(generalKey)) {
        keysToRemove.push(generalKey);
      }
    });

    // Remove all collected keys
    keysToRemove.forEach(key => {
      localStorage.removeItem(key);

    });

  } catch (error) {

  }
};





